import { render, staticRenderFns } from "./wonderousItems.vue?vue&type=template&id=1ebcff66&scoped=true&"
import script from "./wonderousItems.vue?vue&type=script&lang=js&"
export * from "./wonderousItems.vue?vue&type=script&lang=js&"
import style0 from "./wonderousItems.vue?vue&type=style&index=0&id=1ebcff66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebcff66",
  null
  
)

export default component.exports